import { FilterSettingsModel } from "@syncfusion/ej2-react-grids";

const standardFilterOptions: FilterSettingsModel = {
    type: 'Excel',
    ignoreAccent: true
};
export default standardFilterOptions;